import React from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import Merchant from './pages/MerchantApply';
import MedicalTourism from './pages/MedicalTourism';
import Congrats from './pages/Congrats';
import Decline from './pages/Decline';

import withIPAddress from './withIPAddress';
import './App.scss';

const routes = [
  {
    name: 'Merchant',
    pathname: '/',
    component: withIPAddress(Merchant),
    exact: true,
  },
  {
    name: 'Congratulations',
    pathname: '/congrats',
    component: Congrats,
  },
  {
    name: 'Declined',
    pathname: '/declined',
    component: Decline,
  },
  {
    name: 'Medical Tourism',
    pathname: '/medical-tourism',
    component: withIPAddress(MedicalTourism),
  },
];

function App() {
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.pathname}
          exact={route.exact || false}
          render={(routerProps) => (
            <route.component {...routerProps} />
          )}
        />
      ))}
      <Redirect to="/" />
    </Switch>
  );
}

export default withRouter(App);
